import { atom } from 'recoil';
import { RECOIL_KEY } from './key';
/**
 * 订单详情
 */
export const orderDetail = atom({
    key: RECOIL_KEY.ORDER_DETAIL,
    default: undefined
});
